import UserError from './UserError.js'

export class UpdateUserError extends UserError {
  #code

  static GENERIC_UPDATE_USER_ERROR_CODE = 'UPDATE_PHONE_USER_ERROR'
  static WRONG_POSTAL_CODE_ERROR_CODE = 'WRONG_ZIPCODE'

  static create({code}) {
    return new UpdateUserError({code})
  }

  constructor({code}) {
    super()
    this.#code = code
  }

  isWrongPostalCodeError() {
    return this.#code === UpdateUserError.WRONG_POSTAL_CODE_ERROR_CODE
  }

  toJSON() {
    return {
      code: this.#code
    }
  }
}
